import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CampaignStatsHeader } from '@/components/campaigns/CampaignStatsHeader';
import { CampaignActions } from '@/components/campaigns/CampaignActions';
import { CampaignDispatchesTable } from '@/components/campaigns/CampaignDispatchesTable';
import { useCampaignDetail } from '@/hooks/useCampaigns';

function CampaignDetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-8 w-64" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-lg" />
        ))}
      </div>
      <Skeleton className="h-48 rounded-lg" />
    </div>
  );
}

export function CampaignDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading } = useCampaignDetail(id ?? '');

  return (
    <div className="space-y-6">
      <Button
        variant="ghost"
        size="sm"
        className="-ml-2"
        onClick={() => navigate('/campaigns')}
      >
        <ArrowLeft className="h-4 w-4" />
        Campanhas
      </Button>

      {isLoading ? (
        <CampaignDetailSkeleton />
      ) : data ? (
        <>
          <CampaignStatsHeader campaign={data.campaign} stats={data.stats} />

          <CampaignActions campaign={data.campaign} />

          <Card>
            <CardHeader>
              <CardTitle className="text-base">Disparos</CardTitle>
            </CardHeader>
            <CardContent>
              <CampaignDispatchesTable campaignId={data.campaign.id} />
            </CardContent>
          </Card>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Campanha não encontrada.</p>
      )}
    </div>
  );
}
